import { getApi } from '../../utils/api'

export function getCategories(search, params) {
  return getApi({
    endpoint: `idwell-api/api/v3/request/request-categories/`,
    params: {
      ...(search ? { search } : null),
      ...params,
    },
  })
}

export function getCategoriesNG(params) {
  return getApi({
    endpoint: `idwell-api/api/v3/request/request-categories/`,
    params,
  })
}
